$(document).ready(function () {
  var shopifyFileUrl = "//www.explorethousand.com/cdn/shop/files/?v=135611";
  var baseFilePath = shopifyFileUrl.split("?")[0];
  baseFilePath = "https://cdn.shopify.com/s/files/1/0836/6919/files/"; //temp

  $(document).on("thousand:variant:selected", function (e, data) {
    var variantTitleHandle = thousand.utils.handlify(data.option1);
    var data_name = data.name;
    var data_name = data_name.split("-");
    var data_name = data_name[0];
    console.log("data_name", data_name);
    var isNylon = variantTitleHandle.includes("nylon-straps");
    switch (true) {
      case data_name.indexOf("Kids Helmet") >= 0:
        $(".tabs-feature-img-chapter .feature-img").attr(
          "src",
          baseFilePath + "ThsdJR-details-" + variantTitleHandle + ".jpg"
        );
        $(".tab-details .slidecontainer-chapter img").attr(
          "src",
          baseFilePath + "ThsdJR-details-" + variantTitleHandle + ".jpg"
        );
        $(".jr-tablet-details img").attr(
          "src",
          baseFilePath + "ThsdJR-details-" + variantTitleHandle + ".jpg"
        );
        if (isNylon) {
          $(".product-features-section .block-1 img.swap-image").attr(
            "src",
            baseFilePath +
              "thousand-features-helmet-kids-sticker-" +
              variantTitleHandle +
              ".jpg"
          );
          $(".product-features-section .block-2 img.swap-image").attr(
            "src",
            baseFilePath +
              "thousand-features-helmet-kids-interior-" +
              variantTitleHandle +
              ".jpg"
          );
          $(".product-features-section .block-3 img.swap-image").attr(
            "src",
            baseFilePath +
              "thousand-features-helmet-kids-fit-system-" +
              variantTitleHandle +
              ".jpg"
          );
          $(".product-features-section .block-5 img.swap-image").attr(
            "src",
            baseFilePath + "thousand-features-helmet-kids-buckle.jpg"
          );
          $(".product-features-section .block-6 img.swap-image").attr(
            "src",
            baseFilePath +
              "thousand-features-helmet-kids-vents-" +
              variantTitleHandle +
              ".jpg"
          );
          return;
        }
        $(".product-features-section .block-1 img.swap-image").attr(
          "src",
          baseFilePath +
            "ThsdJR-helmet-customizeable-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-2 img.swap-image").attr(
          "src",
          baseFilePath + "ThsdJR-helmet-interior-" + variantTitleHandle + ".jpg"
        );
        $(".product-features-section .block-3 img.swap-image").attr(
          "src",
          baseFilePath +
            "ThsdJR-helmet-fitsystem-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-4 img.swap-image").attr(
          "src",
          baseFilePath + "ThsdJR-helmet-straps.jpg"
        );
        $(".product-features-section .block-5 img.swap-image").attr(
          "src",
          baseFilePath + "ThsdJR-helmet-chinstrap.jpg"
        );
        if (variantTitleHandle === "vivid-violet-with-nylon-straps") {
          $(".product-features-section .block-5 img.swap-image").attr(
            "src",
            baseFilePath + "ThsdJR-helmet-buckle-gray-with-nylon-straps.jpg"
          );
        }
        $(".product-features-section .block-6 img.swap-image").attr(
          "src",
          baseFilePath + "ThsdJR-helmet-vents-" + variantTitleHandle + ".jpg"
        );
        break;
      case data_name.indexOf("Toddler Helmet") >= 0:
        $(".tabs-feature-img-chapter .feature-img").attr(
          "src",
          baseFilePath + "ThsdJR-details-" + variantTitleHandle + ".jpg"
        );
        $(".tab-details .slidecontainer-chapter img").attr(
          "src",
          baseFilePath + "ThsdJR-details-" + variantTitleHandle + ".jpg"
        );
        $(".jr-tablet-details img").attr(
          "src",
          baseFilePath + "ThsdJR-details-" + variantTitleHandle + ".jpg"
        );
        $(".product-features-section .block-1 img.swap-image").attr(
          "src",
          baseFilePath + "thsd-toddler-stickers-" + variantTitleHandle + ".jpg"
        );
        $(".product-features-section .block-2 img.swap-image").attr(
          "src",
          baseFilePath + "thsd-toddler-interior.jpg"
        );
        $(".product-features-section .block-3 img.swap-image").attr(
          "src",
          baseFilePath + "thsd-toddler-dfs-" + variantTitleHandle + ".jpg"
        );
        $(".product-features-section .block-4 img.swap-image").attr(
          "src",
          isNylon
            ? baseFilePath + "ThsdJR-helmet-straps-nylon.jpg"
            : baseFilePath + "ThsdJR-helmet-straps.jpg"
        );
        $(".product-features-section .block-5 img.swap-image").attr(
          "src",
          isNylon
            ? baseFilePath + "ThsdJR-helmet-chinstrap-nylon.jpg"
            : baseFilePath + "ThsdJR-helmet-chinstrap.jpg"
        );
        $(".product-features-section .block-6 img.swap-image").attr(
          "src",
          baseFilePath + "thsd-toddler-vents-" + variantTitleHandle + ".jpg"
        );
        break;
      case data_name.indexOf("Chapter MIPS Helmet") >= 0:
        $(".tabs-feature-img-chapter .feature-img").attr(
          "src",
          baseFilePath + variantTitleHandle + "-details.jpg"
        );
        $(".tab-details .slidecontainer-chapter img").attr(
          "src",
          baseFilePath + variantTitleHandle + "-details-mobile.jpg"
        );
        $(".tabs-feature-img-chapter .feature-tablet-img").attr(
          "src",
          baseFilePath + variantTitleHandle + "-details-tablet.jpg"
        );
        $(".product-features-section-chapter .block-1 img").attr(
          "src",
          baseFilePath +
            "chapter-features-helmet-mips-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section-chapter .block-2 img").attr(
          "src",
          baseFilePath +
            "chapter-features-helmet-light-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section-chapter .block-3 img").attr(
          "src",
          baseFilePath +
            "chapter-features-helmet-visor-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section-chapter .block-4 img").attr(
          "src",
          baseFilePath +
            "chapter-features-helmet-poplock-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section-chapter .block-5 img").attr(
          "src",
          baseFilePath +
            "chapter-features-helmet-vents-" +
            variantTitleHandle +
            ".jpg"
        );
        break;
      case data_name.indexOf("Chapter+ MIPS Helmet") >= 0:
        $(".tabs-feature-img-chapter .feature-img").attr(
          "src",
          baseFilePath + variantTitleHandle + "-details.jpg"
        );
        $(".tab-details .slidecontainer-chapter img").attr(
          "src",
          baseFilePath + variantTitleHandle + "-details-mobile.jpg"
        );
        $(".tabs-feature-img-chapter .feature-tablet-img").attr(
          "src",
          baseFilePath + variantTitleHandle + "-details-tablet.jpg"
        );
        $(".product-features-section-chapter .block-1 img").attr(
          "src",
          baseFilePath + "chapter_-features-mips-" + variantTitleHandle + ".jpg"
        );
        $(".product-features-section-chapter .block-2 img").attr(
          "src",
          baseFilePath +
            "chapter_-features-light-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section-chapter .block-3 img").attr(
          "src",
          baseFilePath +
            "chapter_-features-visor-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section-chapter .block-4 img").attr(
          "src",
          baseFilePath +
            "chapter_-features-poplock-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section-chapter .block-5 img").attr(
          "src",
          baseFilePath +
            "chapter_-features-vents-" +
            variantTitleHandle +
            ".jpg"
        );
        break;
      case data_name.indexOf("Gloves") >= 0:
        $(".tabs-feature-img img").attr(
          "src",
          baseFilePath + variantTitleHandle + "-gloves-details.png"
        );
        $(".tabs-feature-img-chapter img").attr(
          "src",
          baseFilePath + variantTitleHandle + "-gloves-details.png"
        );
        $(".slidecontainer > img").attr(
          "src",
          baseFilePath + variantTitleHandle + "-gloves-details-mobile.jpg"
        );
        $(".feature-img1").attr(
          "src",
          baseFilePath + variantTitleHandle + "-gloves-feature1.jpg"
        );
        $(".feature-img2").attr(
          "src",
          baseFilePath + variantTitleHandle + "-gloves-feature2.jpg"
        );
        break;
      case data_name.indexOf("Light") >= 0 && data_name.indexOf("2.0") === -1:
        var variantTitleHandleLoc = "front";
        if (thousand.utils.handlify(data.option2) == "rear") {
          variantTitleHandleLoc = "rear";
        }
        $(".slidecontainer > img").attr(
          "src",
          baseFilePath +
            "Thsd_Tvl-Lt_set_" +
            variantTitleHandle +
            "-Details.jpg"
        );
        $(".tabs-feature-img img").attr(
          "src",
          baseFilePath +
            "Thsd_Tvl-Lt_set_" +
            variantTitleHandle +
            "-Details.jpg"
        );
        $(".feature-img1").attr(
          "src",
          baseFilePath +
            "Thsd_Tvl-Lt_" +
            variantTitleHandleLoc +
            "_" +
            variantTitleHandle +
            "_On-Bike-Magnet.gif"
        );
        $(".feature-img2").attr(
          "src",
          baseFilePath +
            "Thsd_Tvl-Lt_" +
            variantTitleHandleLoc +
            "_" +
            variantTitleHandle +
            "_On-Bike-Dial.gif"
        );
        break;
      case data_name.indexOf("Heritage Bike & Skate Helmet") >= 0:
        $(".product-features-section-heritage .block-1 img").attr(
          "src",
          baseFilePath +
            "thousand-features-helmet-poplock-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section-heritage .block-3 img").attr(
          "src",
          baseFilePath +
            "thousand-features-helmet-fitsystem-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section-heritage .block-5 img").attr(
          "src",
          baseFilePath +
            "thousand-features-helmet-vents-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section-chapter .block-5 img").attr(
          "src",
          baseFilePath +
            "chapter-features-helmet-vents-" +
            variantTitleHandle +
            ".jpg"
        );
        break;
      case data_name.indexOf("Heritage 2") >= 0:
        $(".product-features-section .block-1 img").attr(
          "src",
          baseFilePath +
            "thousand-features-helmet-h2-active-ventilation-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-2 img").attr(
          "src",
          baseFilePath +
            "thousand-features-helmet-h2-inclusive-fit-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-3 img").attr(
          "src",
          baseFilePath +
            "thousand-features-helmet-h2-pop-lock-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-4 img").attr(
          "src",
          baseFilePath +
            "thousand-features-helmet-h2-classic-features-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-5 img").attr(
          "src",
          baseFilePath +
            "thousand-features-helmet-h2-tail-light-" +
            variantTitleHandle +
            ".jpg"
        );
        break;
	  case data_name.indexOf("Thousand Next Youth Helmet") >= 0:        
        $(".product-features-section .block-1 img").attr(
          "src",
          baseFilePath +
            "thsd-helm-next-details-" +
            variantTitleHandle +
            "-poplock.jpg"
        );        
        $(".product-features-section .block-2 img").attr(
          "src",
          baseFilePath +
            "thsd-helm-next-details-" +
            variantTitleHandle +
            "-light.jpg"
        );
		$(".product-features-section .block-3 img").attr(
          "src",
          baseFilePath +
            "thsd-helm-next-details-" +
            variantTitleHandle +
            "-dfs.jpg"
        );
        $(".product-features-section .block-4 img").attr(
          "src",
          baseFilePath +
            "thsd-helm-next-details-" +
            variantTitleHandle +
            "-vent.jpg"
        );
        break;
      case data_name.indexOf("Crossbody Handlebar Bag") > -1 &&
        data_name.indexOf("Rareform") < 0:
        $(".product-features-section .block-1 img").attr(
          "src",
          baseFilePath +
            "thsd-pdp-features-xbh-lrg-pocket-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-2 img").attr(
          "src",
          baseFilePath +
            "thsd-pdp-features-xbh-zipper-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-3 img").attr(
          "src",
          baseFilePath +
            "thsd-pdp-features-xbh-reflective-logo-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-4 img").attr(
          "src",
          baseFilePath +
            "thsd-pdp-features-xbh-buckle-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-5 img").attr(
          "src",
          baseFilePath +
            "thsd-pdp-features-xbh-strap-pocket-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-6 img").attr(
          "src",
          baseFilePath +
            "thsd-pdp-features-xbh-hb-buckles-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-7 img").attr(
          "src",
          baseFilePath +
            "thsd-pdp-features-xbh-anchor-strap-" +
            variantTitleHandle +
            ".jpg"
        );
        break;
      case data_name.indexOf("Rareform") >= 0:
        $(".product-features-section .block-1 img").attr(
          "src",
          baseFilePath + "thsd-pdp-features-xbh-lrg-pocket-rareform.png"
        );
        $(".product-features-section .block-2 img").attr(
          "src",
          baseFilePath + "thsd-pdp-features-xbh-zipper-rareform.png"
        );
        $(".product-features-section .block-4 img").attr(
          "src",
          baseFilePath + "thsd-pdp-features-xbh-buckle-rareform.png"
        );
        $(".product-features-section .block-5 img").attr(
          "src",
          baseFilePath + "thsd-pdp-features-xbh-strap-pocket-black.jpg"
        );
        $(".product-features-section .block-6 img").attr(
          "src",
          baseFilePath + "thsd-pdp-features-xbh-hb-buckles-rareform.png"
        );
        $(".product-features-section .block-7 img").attr(
          "src",
          baseFilePath + "thsd-pdp-features-xbh-anchor-strap-rareform.png"
        );
        break;
      case data_name.indexOf("Traveler 2.0") >= 0:
        var variantColor = thousand.utils.handlify(data.option1);
        var variantDirectionHandle = thousand.utils.handlify(data.option2);
        if (variantDirectionHandle === "set") {
          variantDirectionHandle = "front";
        }
        $(".product-features-section .block-1 img").attr(
          "src",
          baseFilePath +
            "tvlr2-feature-magnet-" +
            variantDirectionHandle +
            "-" +
            variantColor +
            ".gif"
        );
        $(".product-features-section .block-2 img").attr(
          "src",
          baseFilePath +
            "tvlr2-feature-modes-" +
            variantDirectionHandle +
            "-" +
            variantColor +
            ".jpg"
        );
        $(".product-features-section .block-3 img").attr(
          "src",
          baseFilePath + "tvlr2-feature-both-" + variantColor + "-usbc.jpg"
        );

        break;
      default:
        $(".product-features-section .block-1 img").attr(
          "src",
          baseFilePath +
            "thousand-features-helmet-poplock-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-3 img").attr(
          "src",
          baseFilePath +
            "thousand-features-helmet-fitsystem-" +
            variantTitleHandle +
            ".jpg"
        );
        $(".product-features-section .block-5 img").attr(
          "src",
          baseFilePath +
            "thousand-features-helmet-vents-" +
            variantTitleHandle +
            ".jpg"
        );
    }
  });
});
